import { render, staticRenderFns } from "./teaser_odd.vue?vue&type=template&id=e7681d06&scoped=true&"
import script from "./teaser_odd.vue?vue&type=script&lang=js&"
export * from "./teaser_odd.vue?vue&type=script&lang=js&"
import style0 from "./teaser_odd.vue?vue&type=style&index=0&id=e7681d06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7681d06",
  null
  
)

export default component.exports